import React from 'react';
import { muiCaretDown, muiCaretUp } from '@ally/metronome-icons';
import { Box } from '../../Box';
import { Icon } from '../../Icon';
var SortIndicator = function (_a) {
    var isSorted = _a.isSorted, isSortedDesc = _a.isSortedDesc;
    var isAsc = isSorted && !isSortedDesc;
    return (React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center" }, isSorted && (React.createElement(Icon, { icon: isAsc ? muiCaretUp : muiCaretDown, size: "xs", fill: "slate-5", ml: "xxs", unsupportedCustomWidth: 7, unsupportedCustomHeight: 7, "data-testid": "table-sort-indicator", ariaHidden: true }))));
};
export default SortIndicator;
//# sourceMappingURL=SortIndicator.js.map